import types from '../types';
import baseUrl from '../baseUrl';

const GetVendorPricingAudit = (vendorId) => ({
    type: types.GET_VENDOR_PRICING_AUDIT,
    payload: {},
    meta: {
        type: 'apijson',
        url: `${baseUrl}/vendorPricing/audit/${vendorId}`,
    },
    options: {
        method: 'GET'
    }
})

export default GetVendorPricingAudit;
